import React from 'react';

// Official transparent GENI brain icon for branded loading state
const BRAIN_ICON = "https://customer-assets.emergentagent.com/job_chart-analyzer-107/artifacts/gtg4vc6a_purebrain.png";

export default function GeniLoader({ size = 'md', text = null, inline = false, className = '', iconClassName = '' }) {
  const sizeClasses = {
    sm: 'h-6 md:h-8',
    md: 'h-10 md:h-12',
    lg: 'h-14 md:h-16'
  };

  const containerClassName = inline
    ? `inline-flex items-center justify-center ${className}`.trim()
    : `flex flex-col items-center justify-center h-full w-full gap-3 ${className}`.trim();

  return (
    <div className={containerClassName} data-testid="geni-loader">
      <img
        src={BRAIN_ICON}
        alt="Loading"
        className={`${sizeClasses[size]} block w-auto bg-transparent object-contain animate-pulse opacity-90 ${iconClassName}`.trim()}
      />
      {text && (
        <p className="text-white/50 text-sm">{text}</p>
      )}
    </div>
  );
}
